import { Box, Stack } from '@mui/system'
import React, { useEffect, useState } from 'react'
import CategoryAccordion from './filters/CategoryAccordion'
import RangeSlider from './filters/RangeSlider'
import SexFilter from './filters/SexFilter'

const toArrayCategory = (category) => {
    let cat = [];

    for (let [key, value] of Object.entries(category)) {
        if(value) {
            cat.push(key)
        }
    }

    return cat;
}

const FilterAfterFetch = ({ setFilters, filter, maxPrice, categories, api }) => {
    const [price, setPrice] = useState(null);
    const [sex, setSex] = useState(filter['sex'] === 'Woman' ? [true, false] : filter['sex'] === 'Man' ? [false, true] : [true, true]);
    const [category, setCategory] = useState([]);

    useEffect(() => {
        var sexStr = 'All'

        if(JSON.stringify(sex) === JSON.stringify([true, false])) { 
            sexStr = 'Woman'
        } else if(JSON.stringify(sex) === JSON.stringify([false, true])) {
            sexStr = 'Man'
        } else {
            sexStr = 'All'
        }

        setFilters({
            price: price ? price : [0, 0],
            sex: sexStr,
            category: category ? toArrayCategory(category) : {}
        });
        
    }, [price, sex, category, setFilters])

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Stack direction="column" spacing={1} alignItems="center">
                {
                    api.conf.visualsearch_displaygenderfilter ?
                    <SexFilter sex={setSex}/>
                    : <></>
                }
                {
                    api.conf.visualsearch_displaypricefilter ?
                    <RangeSlider setPrice={setPrice} price={maxPrice} api={api}/>
                    : <></>
                }
                {
                    api.conf.visualsearch_displaycategoryfilter && categories ? 
                    <CategoryAccordion setCategory={setCategory} categories={categories}/>
                    : <></>
                }
            </Stack>
        </Box>

    )
}

export default FilterAfterFetch